const SECTION_HEADER_NUMBER_RE = /^(\d+)\.\s*/;

export const extractFeedbackSectionOrder = (header = "") => {
  const match = String(header).match(SECTION_HEADER_NUMBER_RE);
  return match ? Number(match[1]) : null;
};

const isFeedbackSummaryItem = (item, index, items) => {
  if (!item || index !== items.length - 1) {
    return false;
  }

  return extractFeedbackSectionOrder(item.header) === null;
};

export const orderScenarioFeedbackJson = (feedbackJson) => {
  if (!Array.isArray(feedbackJson) || feedbackJson.length <= 1) {
    return feedbackJson;
  }

  const hasNumberedSections = feedbackJson.some(
    (item) => extractFeedbackSectionOrder(item?.header) !== null,
  );

  if (!hasNumberedSections) {
    return feedbackJson;
  }

  const lastIndex = feedbackJson.length - 1;
  const lastItem = feedbackJson[lastIndex];
  const hasSummary = isFeedbackSummaryItem(lastItem, lastIndex, feedbackJson);
  const criteriaItems = hasSummary
    ? feedbackJson.slice(0, -1)
    : feedbackJson;

  const sortedCriteria = [...criteriaItems].sort((left, right) => {
    const leftOrder = extractFeedbackSectionOrder(left?.header);
    const rightOrder = extractFeedbackSectionOrder(right?.header);

    if (leftOrder === null && rightOrder === null) {
      return 0;
    }

    if (leftOrder === null) {
      return 1;
    }

    if (rightOrder === null) {
      return -1;
    }

    return leftOrder - rightOrder;
  });

  return hasSummary ? [...sortedCriteria, lastItem] : sortedCriteria;
};
